<template>
  <div class="view pa24">
    <el-button type="primary" @click="openDialog()">新增模板</el-button>
    <el-table class="mt16" :data="tableData" v-loading="loading" border>
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="name" label="模板名称" min-width="120" show-overflow-tooltip />
      <el-table-column prop="signName" label="签名" width="120" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.signName || '系统默认' }}</template>
      </el-table-column>
      <el-table-column prop="templateCode" label="阿里云模板CODE" min-width="160" show-overflow-tooltip />
      <el-table-column prop="contentExample" label="示例文案" min-width="220" show-overflow-tooltip />
      <el-table-column prop="variablesJson" label="变量" width="140" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
            {{ scope.row.status === 1 ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="openDialog(scope.row)">编辑</el-button>
          <el-button type="text" @click="toggleStatus(scope.row)">
            {{ scope.row.status === 1 ? '停用' : '启用' }}
          </el-button>
          <el-button type="text" style="color:#F56C6C" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="d-flex justify-content-end mt16">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :current-page.sync="pageNum"
        :page-size="pageSize"
        @current-change="loadData"
      />
    </div>

    <el-dialog :title="form.templateId ? '编辑模板' : '新增模板'" :visible.sync="visible" width="560px">
      <el-form :model="form" label-width="120px">
        <el-form-item label="模板名称" required>
          <el-input v-model="form.name" maxlength="64" placeholder="内部识别名称" />
        </el-form-item>
        <el-form-item label="短信签名">
          <el-input v-model="form.signName" maxlength="32" placeholder="留空使用系统默认签名" />
        </el-form-item>
        <el-form-item label="模板CODE" required>
          <el-input v-model="form.templateCode" maxlength="64" placeholder="阿里云审核通过的模板CODE" />
        </el-form-item>
        <el-form-item label="变量">
          <el-input v-model="form.variablesJson" placeholder='如 name,product 或 ["name","product"]' />
        </el-form-item>
        <el-form-item label="示例文案">
          <el-input
            type="textarea"
            :rows="3"
            v-model="form.contentExample"
            placeholder="如：尊敬的${name}，欢迎了解${product}"
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addSmsTemplate,
  updateSmsTemplate,
  deleteSmsTemplate,
  querySmsTemplatePage
} from "@/api/sms";

export default {
  name: "SmsTemplateList",
  data() {
    return {
      loading: false,
      saving: false,
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      visible: false,
      form: this.emptyForm()
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    emptyForm() {
      return {
        templateId: null,
        name: "",
        signName: "",
        templateCode: "",
        variablesJson: "",
        contentExample: "",
        status: 1
      };
    },
    loadData() {
      this.loading = true;
      querySmsTemplatePage({ pageNum: this.pageNum, pageSize: this.pageSize })
        .then(res => {
          const page = res && res.data;
          this.tableData = (page && page.list) || [];
          this.total = (page && page.total) || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDialog(row) {
      this.form = row
        ? {
            templateId: row.id,
            name: row.name,
            signName: row.signName || "",
            templateCode: row.templateCode,
            variablesJson: row.variablesJson || "",
            contentExample: row.contentExample || "",
            status: row.status
          }
        : this.emptyForm();
      this.visible = true;
    },
    save() {
      if (!this.form.name || !this.form.templateCode) {
        this.$message.warning("请填写模板名称和模板CODE");
        return;
      }
      this.saving = true;
      const api = this.form.templateId ? updateSmsTemplate : addSmsTemplate;
      api(this.form)
        .then(() => {
          this.$message.success("保存成功");
          this.visible = false;
          this.loadData();
        })
        .finally(() => {
          this.saving = false;
        });
    },
    toggleStatus(row) {
      updateSmsTemplate({
        templateId: row.id,
        status: row.status === 1 ? 0 : 1
      }).then(() => {
        this.$message.success("已更新");
        this.loadData();
      });
    },
    remove(row) {
      this.$confirm("确认删除该模板？", "提示", { type: "warning" })
        .then(() => deleteSmsTemplate({ templateId: row.id }))
        .then(() => {
          this.$message.success("已删除");
          this.loadData();
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.mt16 {
  margin-top: 16px;
}
</style>
